export default __webpack_public_path__ + "static/media/lux-bg-large.5c36b67b.jpg";